<template>
    <div>
        <h2 class="mb-8">{{ __('store.parking') }}</h2>

        <div class="d-flex flex-column gap-1 mb-8">
            <div class="d-flex flex-row gap-2">
                <Center vertical>
                        <span
                            class="switch switch-sm switch-outline switch-icon switch-success d-inline-block mt-1 mb-n1">
                            <label>
                                <input type="checkbox" v-model="settings.is_free">
                                <span></span>
                            </label>
                        </span>
                </Center>
                <Center vertical>
                    <div style="padding-top: 1px;">{{ __('parking.free_parking') }}</div>
                </Center>
            </div>

            <div class="d-flex flex-row gap-2">
                <Center vertical>
                        <span
                            class="switch switch-sm switch-outline switch-icon switch-success d-inline-block mt-1 mb-n1">
                            <label>
                                <input type="checkbox" v-model="settings.is_close">
                                <span></span>
                            </label>
                        </span>
                </Center>
                <Center vertical>
                    <div style="padding-top: 1px;">{{ __('parking.close_parking') }}</div>
                </Center>
            </div>

            <div class="row mt-3" :class="{'opacity-50': settings.is_close}">
                <div class="col-lg-6">
                    <label class="font-weight-bold">{{ __('parking.distance') }}</label>
                    <select class="form-control" :disabled="settings.is_close"
                            @change="(e) => settings.distance = e.target.value">
                        <option :selected="settings.distance === 0" disabled>
                            {{ __('actions.select') }}
                        </option>
                        <option v-for="duration in [2,5,10,15,20,30]" :value="duration"
                                :selected="settings.distance === duration">
                            ca. {{ duration }}min.
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-primary" @click="saveSettings">
            <i class="fas fa-save"/>
            {{ __('actions.submit') }}
        </button>
    </div>
</template>

<script>

import Center from '@components/Layout/Center.vue'
import Navigation from './Nav/Navigation.vue'

export default {
    layout: Navigation,

    components: {Center},

    props: {
        store: Object,
        storeUuid: String,
    },

    data() {
        return {
            settings: this.$inertia.form({
                is_free: false,
                is_close: false,
                distance: 0,
            }),
        }
    },

    beforeMount() {
        if (this.store && this.store.attributes.parking !== null) {
            this.settings = this.$inertia.form(this.store.attributes.parking)
        }
    },

    methods: {
        saveSettings() {
            if (this.settings.is_close && this.settings.distance > 0) {
                this.settings.distance = 0
            }

            this.settings.post(this.$route('store.parking', [this.storeUuid]));
        },
    },
}
</script>
